import type { TaskEffort } from '@/components/Configuracao/esforcoTimeTypes'

const TIME_REGEX = /^([0-9]{2}):([0-9]{2}):([0-9]{2})$/

export function formatTotalHours(tasks: TaskEffort[]): string {
  let totalSeconds = 0
  tasks.forEach((t) => {
    const parts = t.hours.split(':')
    const h = parseInt(parts[0] || '0', 10)
    const m = parseInt(parts[1] || '0', 10)
    const s = parseInt(parts[2] || '0', 10)
    totalSeconds += h * 3600 + m * 60 + s
  })
  const totH = Math.floor(totalSeconds / 3600)
  const totM = Math.floor((totalSeconds % 3600) / 60)
  return `${totH}h ${totM}m`
}

export function normalizeTaskHours(hours: string): string {
  return TIME_REGEX.test(hours) ? hours : '01:00:00'
}
